const API_URL = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = 'stv_analytics_session_id';
const SOURCE_KEY = 'stv_analytics_source_snapshot';

export function getAnalyticsSessionId() {
  let sessionId = localStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

function getUrlParams() {
  if (typeof window === 'undefined') return new URLSearchParams();
  return new URLSearchParams(window.location.search);
}

export function getTrackingContext() {
  if (typeof window === 'undefined') return {};

  const params = getUrlParams();
  const snapshotRaw = sessionStorage.getItem(SOURCE_KEY);
  let snapshot = null;
  try {
    snapshot = snapshotRaw ? JSON.parse(snapshotRaw) : null;
  } catch {
    snapshot = null;
  }

  const current = {
    referrer: document.referrer || null,
    utm_source: params.get('utm_source') || null,
    utm_medium: params.get('utm_medium') || null,
    utm_campaign: params.get('utm_campaign') || null,
    utm_term: params.get('utm_term') || null,
    utm_content: params.get('utm_content') || null,
    landing_path: `${window.location.pathname}${window.location.search || ''}`,
    current_url: window.location.href,
    pathname: window.location.pathname,
  };

  const shouldRefresh = Boolean(current.referrer || current.utm_source || current.utm_medium || current.utm_campaign || !snapshot);
  if (shouldRefresh) {
    snapshot = current;
    sessionStorage.setItem(SOURCE_KEY, JSON.stringify(snapshot));
  }

  return {
    ...(snapshot || current),
    current_url: window.location.href,
    pathname: window.location.pathname,
  };
}

export async function trackEvent(eventType, page, value = null, extra = {}) {
  const session_id = getAnalyticsSessionId();
  const metadata = {
    ...getTrackingContext(),
    ...(extra.metadata || {}),
  };

  try {
    await fetch(`${API_URL}/api/track/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session_id,
        event_type: eventType,
        page,
        value: value != null ? String(value) : null,
        ...extra,
        metadata,
      }),
    });
  } catch {
    // ignore analytics failures
  }
}
